import useSlingApi from '@sdk/api/useSlingApi';
import useConfig from '@sdk/config/useConfig';
import gettext from '@sdk/lang/gettext';
import { PosIntegrations, Integration } from '@sdk/integrations/types';

import { isShift4Integration } from './isShift4Integration';

type Result = {
  connect: () => Promise<void>;
};

const useConnect = (integration: Integration): Result => {
  const api = useSlingApi();
  const { SLING_INTEGRATIONS_URL } = useConfig();

  const connect = async (): Promise<void> => {
    const { data: integrations } = await api.integrations.getAvailableIntegrations();

    const integrationIdx = integrations.findIndex(({ type, brands }) => {
      if (isShift4Integration(integration.type) && brands[integration.type]) {
        return true;
      }
      return type === integration.type;
    });

    // Integration is not found among available integrations
    if (integrationIdx === -1) {
      throw new Error(
        gettext(
          'Integration you tried to connect to may be outdate. Please refresh your browser and try again.'
        )
      );
    }

    const connectIntegration = integrations[integrationIdx];

    if (isShift4Integration(integration.type)) {
      connectIntegration.url = connectIntegration.brands[integration.type].url;
    }

    // In case of Square we would redirect to integrations side install url; this should work for most platforms
    // which should be gradually moved to the install url, just Shopify and other parametrized platforms would
    // require some additional parameter handling
    const url =
      connectIntegration.type === PosIntegrations.square
        ? `${SLING_INTEGRATIONS_URL}/install/${PosIntegrations.square}`
        : connectIntegration.url;

    location.href = url;
  };

  return { connect };
};

export default useConnect;
